"use client";

import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export interface VerifiedBadgeProps {
  /** Size in pixels (default: 20) */
  size?: number;
  /** Additional CSS classes */
  className?: string;
  /** Accessible label */
  label?: string;
}

export default function VerifiedBadge({
  size = 20,
  className,
  label = "Verified"
}: VerifiedBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-[#FF1B8D] shadow-sm flex-shrink-0",
        className
      )}
      style={{ width: size, height: size }}
      title={label}
      role="img"
      aria-label={label}
    >
      <Check
        className="text-white"
        style={{ width: size * 0.6, height: size * 0.6 }}
        strokeWidth={3}
        aria-hidden="true"
      />
    </span>
  );
}
